import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  AppScenariosBiomarkerGetResultsByAppointmentApplicationPayloadBiomarkerWithResultDTO,
  UnprocessedBiomarkerElement,
  UserGenderEnum
} from '../types/apiGeneratedTypes';
import { Alert } from '../api/staff';

export interface AlertsPageState {
  isAlertsLoading: boolean;
  alertsList: UnprocessedBiomarkerElement[] | null;
  alertsListByAppointment:
    | AppScenariosBiomarkerGetResultsByAppointmentApplicationPayloadBiomarkerWithResultDTO[]
    | null;
  alertsCount: number | null;
  isAlertTestResultModalVisible: boolean;
  isDeleteTestResultModalVisible: boolean;
  isSingleTestResultModalVisible: boolean;
  selectedTestResultId: number | null;
  selectedTestResultMemberId: string | null;
  selectedTestResultMemberDOB: string | null;
  selectedTestResultMemberName: string | null;
  selectedTestResultMemberGender: UserGenderEnum | null;
  isUpdateBiomarkersResultsModalVisible: boolean;
  isDeleteSingleBiomarkerResultModalVisible: boolean;
  selectedTestResultIdToDelete: number | null;
  // Staff alerts
  staffAlerts: Alert[] | null;
  isStaffAlertsLoading: boolean;
  staffAlertsError: string | null;
}

export const initialState: AlertsPageState = {
  isAlertsLoading: false,
  alertsList: null,
  alertsListByAppointment: null,
  alertsCount: null,
  isAlertTestResultModalVisible: false,
  isDeleteTestResultModalVisible: false,
  isSingleTestResultModalVisible: false,
  selectedTestResultId: null,
  selectedTestResultMemberId: null,
  selectedTestResultMemberDOB: null,
  selectedTestResultMemberName: null,
  selectedTestResultMemberGender: null,
  isUpdateBiomarkersResultsModalVisible: false,
  isDeleteSingleBiomarkerResultModalVisible: false,
  selectedTestResultIdToDelete: null,
  // Staff alerts
  staffAlerts: null,
  isStaffAlertsLoading: false,
  staffAlertsError: null
};

const alertsPageSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    setIsClinicsLoading(state, action: PayloadAction<boolean>) {
      state.isAlertsLoading = action.payload;
    },
    setAlertsCount(state, action: PayloadAction<number>) {
      state.alertsCount = action.payload;
    },
    setAlertsList(state, action: PayloadAction<UnprocessedBiomarkerElement[]>) {
      state.alertsList = action.payload;
    },
    changeShowAlertTestResultModalVisibility(
      state,
      action: PayloadAction<boolean>
    ) {
      state.isAlertTestResultModalVisible = action.payload;
    },
    changeSingleTestResultModalVisibility(
      state,
      action: PayloadAction<boolean>
    ) {
      state.isSingleTestResultModalVisible = action.payload;
    },
    changeDeleteTestResultModalVisibility(
      state,
      action: PayloadAction<boolean>
    ) {
      state.isDeleteTestResultModalVisible = action.payload;
    },
    setSelectedTestResultId(state, action: PayloadAction<number | null>) {
      state.selectedTestResultId = action.payload;
    },
    setSelectedTestResultMemberId(state, action: PayloadAction<string | null>) {
      state.selectedTestResultMemberId = action.payload;
    },
    setSelectedTestResultMemberDOB(
      state,
      action: PayloadAction<string | null>
    ) {
      state.selectedTestResultMemberDOB = action.payload;
    },
    setSelectedTestResultMemberName(
      state,
      action: PayloadAction<string | null>
    ) {
      state.selectedTestResultMemberName = action.payload;
    },
    setSelectedTestResultMemberGender(
      state,
      action: PayloadAction<UserGenderEnum | null>
    ) {
      state.selectedTestResultMemberGender = action.payload;
    },
    setAlertsListByAppointment(
      state,
      action: PayloadAction<
        | AppScenariosBiomarkerGetResultsByAppointmentApplicationPayloadBiomarkerWithResultDTO[]
        | null
      >
    ) {
      state.alertsListByAppointment = action.payload;
    },
    changeUpdateBiomarkersResultsModalVisibility(
      state,
      action: PayloadAction<boolean>
    ) {
      state.isUpdateBiomarkersResultsModalVisible = action.payload;
    },
    changeDeleteSingleBiomarkerResultModalVisibility(
      state,
      action: PayloadAction<boolean>
    ) {
      state.isDeleteSingleBiomarkerResultModalVisible = action.payload;
    },
    setSelectedTestResultIdToDelete(
      state,
      action: PayloadAction<number | null>
    ) {
      state.selectedTestResultIdToDelete = action.payload;
    },
    // Staff alerts reducers
    setStaffAlerts(state, action: PayloadAction<Alert[]>) {
      state.staffAlerts = action.payload;
    },
    setIsStaffAlertsLoading(state, action: PayloadAction<boolean>) {
      state.isStaffAlertsLoading = action.payload;
    },
    setStaffAlertsError(state, action: PayloadAction<string | null>) {
      state.staffAlertsError = action.payload;
    }
  }
});

export const {
  setIsClinicsLoading,
  setAlertsCount,
  setAlertsList,
  changeShowAlertTestResultModalVisibility,
  setSelectedTestResultId,
  setSelectedTestResultMemberName,
  setSelectedTestResultMemberGender,
  changeDeleteTestResultModalVisibility,
  changeSingleTestResultModalVisibility,
  setAlertsListByAppointment,
  setSelectedTestResultMemberId,
  setSelectedTestResultMemberDOB,
  changeUpdateBiomarkersResultsModalVisibility,
  changeDeleteSingleBiomarkerResultModalVisibility,
  setSelectedTestResultIdToDelete,
  // Staff alerts actions
  setStaffAlerts,
  setIsStaffAlertsLoading,
  setStaffAlertsError
} = alertsPageSlice.actions;
export default alertsPageSlice.reducer;
